import React from 'react';

type PricingComponentProps = {
  children: JSX.Element;
};

function Pricing({ children }: PricingComponentProps) {
  return <div className="pricing__route">{children}</div>;
}

export default Pricing;
